import DownloadAppBottom from './views/index.c';
export default DownloadAppBottom;
